import { render } from "./marketplace_setup_submitted.html?vue&type=template&id=0f78c22f&scoped=true&external"
import script from "./marketplace_setup_submitted.js?vue&type=script&lang=js&external"
export * from "./marketplace_setup_submitted.js?vue&type=script&lang=js&external"

import "./MicrosoftMarketplaceSetupSubmitted.vue?vue&type=style&index=0&id=0f78c22f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f78c22f"]])

export default __exports__